import * as i from "../../contracts";
/* istanbul ignore next */
export const alphabeticalSorting = (x: i.League, y: i.League): number => {
    if (!x.name) { return 1; }
    if (!y.name) { return -1; }

    return x.name.toLocaleLowerCase().localeCompare(y.name.toLocaleLowerCase());
}